"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var useThenable_exports = {};
__export(useThenable_exports, {
  useThenable: () => useThenable
});
module.exports = __toCommonJS(useThenable_exports);
var React = __toESM(require("react"), 1);
function useThenable(create) {
  var [promise] = React.useState(create);
  var initialState = [
    false,
    void 0
  ];
  promise.then(function(result) {
    initialState = [
      true,
      result
    ];
  });
  var [state, setState] = React.useState(initialState);
  var [resolved] = state;
  React.useEffect(function() {
    var cancelled = false;
    var resolve = async function resolve2() {
      var result;
      try {
        result = await promise;
      } finally {
        if (!cancelled) {
          setState([
            true,
            result
          ]);
        }
      }
    };
    if (!resolved) {
      resolve();
    }
    return function() {
      cancelled = true;
    };
  }, [
    promise,
    resolved
  ]);
  return state;
}
//# sourceMappingURL=useThenable.js.map
